
<template>
    <div class="users_list mt-3">
        <ul class="user_list_to_insert">
            <li v-for="(item,index) in group_list" @click.prevent="set_active(item,index)"  :class="group_class(item)" class="border cursor-pointer shadow-1 mt-1 mb-2">
                <div class="user_profile bg-gradient-primary bd-callout  position-relative px-2 p-1" :class="group_class_bd(item)">
                    <div class="d-flex flex-row pt-2 pb-1">
                        <div class="user_attrib ml-3">
                            <div class="name d-block fw-700 text-dark">{{ item.title }}</div>
                            <div class="company small text-dark">{{ item.uniq_id }}</div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'groups/getUfilterField',
    mutationType: 'groups/updateUfilterField',
});

export default {
    name: "groups_list",
    props : {
        groups : {
            type : Array,
        }
    },

    data () {
        return {
            group_list : this.groups
        }
    },

    created () {
        EventBus.$on('check_list',this.activate_list);
    },

    methods : {

        group_class_bd(group) {
            if(group.hasOwnProperty('min_qual')) {
                if(group.min_qual > 0) {
                    return 'bd-callout-danger';
                }
            }
            return 'bd-callout-success';
        },

        activate_list(flag) {
            flag = flag.active;
            let tmp = this.active_groups_list;

            for (let j = this.group_list.length - 1; j >= 0; j -= 1) {
                let is_find = false;

                for (let i = tmp.length - 1; i >= 0; i -= 1) {
                    if (parseInt(tmp[i].id) === parseInt(this.group_list[j].id)) {
                        if (flag === false) {
                            tmp.splice(i, 1);
                        }
                        is_find = true;
                    }
                }

                if (is_find === false) {
                    if (flag === true && !this.is_excluded(this.group_list[j])) {
                        tmp.push(this.group_list[j]);
                    }
                }
            }


            if (tmp.length > 0) {
                tmp.reverse();
            }
        },

        set_active(item, index) {
            if (this.is_excluded(item)) {
                return;
            }

            item.is_active = item.is_active !== true;
            //for redraw
            this.$set(this.group_list, index, item);
            this.store_cache(item);
        },

        store_cache(item) {
            let is_find = false;
            let tmp = this.active_groups_list;
            //https://gist.github.com/chad3814/2924672
            for (let i = tmp.length - 1; i >= 0; i -= 1) {
                if (tmp[i].id === item.id) {
                    tmp.splice(i, 1);
                    is_find = true;
                }
            }

            if (is_find === false) {
                tmp.push(item);
            }
        },

        group_class(item) {

            if (this.is_excluded(item) || item.published == false) {
                return 'disabled';
            }

            if (this.is_active(item)) {
                return 'active bg-selected-50';
            }
        },

        is_active(item) {
            if (this.active_groups_list.length > 0) {
                for (let i = this.active_groups_list.length - 1; i >= 0; i -= 1) {
                    if (parseInt(this.active_groups_list[i].id) === parseInt(item.id)) {
                        return true;
                    }
                }
            }

            return false;
        },


        is_excluded(item) {
            console.log('check_exclude',item);
            if (this.exclude_users.length > 0) {
                for (let i = this.exclude_users.length - 1; i >= 0; i -= 1) {
                    if (parseInt(this.exclude_users[i].id) === parseInt(item.id)) {
                        return true;
                    }
                }
            }
            return false;
        },
    },

    computed: {

        ...mapFields([
            'active_groups',
            'exclude'
        ]),

        active_groups_list : {
            get() {
                return this.active_groups;
            },
            set(arr) {
                this.$store.dispatch('groups/SET_ACTIVE_GROUPS_LIST', arr);
            }
        },
        exclude_users () {
            return this.exclude;
        }
    },

    watch: {
        groups(value) {
            this.group_list = value;
        }
    },

}
</script>


<style scoped>
.users_list {
    max-height: 80vh;
    overflow: auto;
}

.user_list_to_insert {
    margin-left: 0;
    padding-left: 0;
    width:98%;
}
</style>
